<!--
 * @Author: 317473294@qq.com
 * @Date: 2022-06-27 11:14:01
 * @LastEditTime: 2024-09-29 22:28:53
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/components/word/zdzy-table-fuhe.vue
-->
<template>
  <div class="zdzy-table">
    <el-table :data="tableData" show-overflow-tooltip="false" :show-header="true" highlight-current-row @current-change="handleCurrentChange"
      :header-cell-style="{background:'#F8FAFC'}" border style="width: 100%" cell-class-name="table-cell">
      <el-table-column  fixed type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="word" label="单词" width="120"></el-table-column>
      <el-table-column prop="yinbiao" label="音标" width="120"> </el-table-column>
      <el-table-column prop="player" label="播放" width="100" header-align="center"  > 
        <template v-slot="scope">
          <audio id="audio" :src="scope.row.mediaadress" hidden="true">
          </audio>
          <div class="el-icon-video-play btnPlay"  @click="playerAudio(scope.row.mediaadress)" alt="播放"></div>
       </template>
      </el-table-column>
      <el-table-column prop="wordtranslate" label="单词中文" width="200">
        <!-- <template slot-scope="scope">
          
          <span :style="{color:scope.row.color}">{{ scope.row.state }}</span>
        </template> -->
      <!-- </el-table-column> -->
      </el-table-column>
  
      <el-table-column prop="tip" label="记忆提示" width="auto">
        <template v-slot="scope">
          <div v-html="scope.row.tip"></div>
       </template>
      </el-table-column>
      <el-table-column prop="sentence" label="单词句子" width="auto">
      </el-table-column>
      <el-table-column prop="sentanctranslate" label="句子翻译" width="auto">
      </el-table-column>
      <el-table-column prop="mediaadress" label="单词音频地址" width="200">
      </el-table-column>
      <el-table-column prop="other" label="其他" width="auto">
      </el-table-column>
      <el-table-column prop="type" label="类型" width="auto">
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button v-permission="'edit'" class="groupbtn" type="primary" @click="handleClickEdit(scope.row)"  size="small">编辑</el-button>
          <!-- <el-button class="groupbtn" type="text" size="small" @click="handleClickDetail(scope.row)">详情</el-button> -->
          <el-button v-permission="'delete'" class="groupbtn" type="danger" size="small" @click="handleClickDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>



  </div>
</template>
<script>
  export default {
    name: "zdzy-table-fuhe",
    props: ["tableData"],
    data() {
      return {
        currentRow: null,
      }
    },
    created() {
            // this.$currentRouterToMeta(this.$route)
    },
    methods: {
      playerAudio(src){
        // //console.log(src)
       let audio=document.getElementById('audio')
       audio.src=src;
       audio.play()
      },
      handleClick(row_info) {

      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      handleClickDetail(row) {
        this.$emit("dataDouctDetail", row)
      },
      handleClickDelete(row){
        this.$emit("handleClickDelete", row)
      },
      //编辑单词
      handleClickEdit(row){
        this.$emit("handleClickEdit", row)
      }
    },
  }
</script>
<style >
  .zdzy-table {
    display: flex;
    width: 100%;
    flex-direction: column;
  }

  .el-pagination {
    margin-top: 10px;
  }

  .groupbtn {
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }

  >>>.el-button+.el-button {
    margin-left: 5px;
  }
  .btnPlay{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    cursor: pointer;
  }
  /* >>>.el-table >>>.cell {
 	white-space: pre !important;
  	overflow: hidden !important;
  	text-overflow: ellipsis !important;
} */
.table-cell .cell{
  white-space: nowrap !important;
}

</style>


// WEBPACK FOOTER //
// src/components/word/zdzy-table-fuhe.vue